var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.53,
    height: 8,
    viewBox: "0 0 14.53 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M.212,7.783l6.534,6.532a.734.734,0,0,0,1.039-1.036L1.769,7.265,7.784,1.252A.734.734,0,0,0,6.746.214L.212,6.746A.74.74,0,0,0,.212,7.783Z",
    transform: "translate(0 8) rotate(-90)",
    fill: "#bbc0ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.c69e23f976e9c0d532a8a09189bff622.svg";
export { ForwardRef as ReactComponent };